export const UPDATE_DEV_HAS_FF_OVERRIDE = 'app/dev/UPDATE_DEV_HAS_FF_OVERRIDE'
export const UPDATE_LIVE_FF_STATE = 'app/dev/UPDATE_LIVE_FF_STATE'
export const REVERT_TO_LIVE_FF_STATE = 'app/dev/REVERT_TO_LIVE_FF_STATE'
